import { GlSprintf } from '@gitlab/ui';
export default {
    name: 'BoldText',
    components: {
        GlSprintf
    },
    props: {
        message: {
            type: String,
            required: true
        }
    }
};
